<template>
  <el-upload ref="upload"
             action="#"
             class="upload-statement"
             list-type="text"
             accept=".doc,.docx"
             :limit="1"
             :auto-upload="false"
             :http-request="uploadFile"
             :on-remove="handleRemove"
             :on-exceed="handleExceed"
             :on-change="handleChange"
             :on-success="uploadSuccess"
             :on-error="error"
             :before-upload="beforeUpload">
    <div slot="tip" class="el-upload__tip">只能上传doc/docx文件，且不超过20MB</div>
    <el-button class="selectBtn" slot="trigger" size="small" type="primary">选取文件</el-button>
    <el-button class="uploadBtn" style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
  </el-upload>
</template>
<script>

import {uploadAgree} from "@/api/accident/upload";

export default {
  inject: {isDisabled: {default: () => ({value: false})}},
  props: {
    recordId: {
      type: String,
      required: true
    },
    statementUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    beforeUpload(file) {
      if (!'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'.split(',').includes(file.type)) {
        this.$message.error('只能上传doc/docx文件');
        return false;
      } else if (file.size / 1024 / 1024 > 20) {
        this.$message.error('上传文件不能大于20MB')
        return false
      }
      return true;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadFile({file}) {
      const formData = new FormData();
      formData.append('file', file);
      uploadAgree(this.recordId, formData)
        .then(({data}) => {
          console.log(data)
          this.$message.success('上传成功');
        })
    },
    handleExceed(files) {
      this.$refs.upload.clearFiles()
      this.$refs.upload.handleStart(files[0])
    },
    uploadSuccess(response, file, fileList) {
      if (response.code === 200) {
        //状态码为200时则上传成功
        this.$message.success('上传成功');
      } else {
        this.$message.success('上传失败');
      }
    }
  }
};
</script>
<style lang="less">
.upload-statement {
  max-width: 600px;

  .el-upload-list__item.is-success.focusing {
    .el-icon-close-tip {
      display: none !important;
    }
  }

  .el-upload__tip {
    color: #17ECFE;
    margin-bottom: 25px;
  }

  .selectBtn {
    background: #faa303;
  }

  .uploadBtn {
    background: #0ebd35;
  }

  .el-upload-list .el-upload-list--text {
    color: #0EBD35;
  }
}
</style>
